import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './talenthardwork.json';

const TalentHardwork = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Discuss talent vs. effort, growth mindset, and success factors. B2 English exercises with grammar, reading, and vocabulary practice."
            level="B2"
            title="Talent vs Hard Work"
            image="/Images/talent.webp"
            seoTitle="Free English Lesson Plans: Talent vs Hard Work"
            seoDescription="Discuss talent vs. effort, growth mindset, and success factors. B2 English exercises with grammar, reading, and vocabulary practice."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default TalentHardwork;


